export default __webpack_public_path__ + "static/sea_breath-5914cc6a90fc94280cdd3d0312d46b93.png";